import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import Menu from '@/views/Menu.vue';
import Rules from '@/views/Rules.vue';
import Prizes from '@/views/Prizes.vue';
import Contest from '@/views/Contest.vue';
import ContestQuestion from '@/views/ContestQuestion.vue';
import ContestPersonal from '@/views/ContestPersonal.vue';
import ContestLegals from '@/views/ContestLegals.vue';
import ContestSubmit from '@/views/ContestSubmit.vue';
import ContestEnd from '@/views/ContestEnd.vue';
import ContestWinners from '@/views/ContestWinners.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/menu',
      name: 'Menu',
      component: Menu,
    },
    {
      path: '/rules',
      name: 'rules',
      component: Rules,
    },
    {
      path: '/prizes',
      name: 'prizes',
      component: Prizes,
    },
    {
      path: '/contest',
      component: Contest,
      children: [
        {
          path: '',
          redirect: 'winners',
        },
        {
          path: 'question',
          name: 'contest question',
          component: ContestQuestion,
        },
        {
          path: 'personal',
          name: 'contest personal',
          component: ContestPersonal,
        },
        {
          path: 'legals',
          name: 'contest legals',
          component: ContestLegals,
        },
        {
          path: 'submit',
          name: 'contest submit',
          component: ContestSubmit,
        },
        {
          path: 'end',
          name: 'contest end',
          component: ContestEnd,
        },
        {
          path: 'winners',
          name: 'contest winners',
          component: ContestWinners,
        },
      ],
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});
